import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { LANGUAGES } from "../lib/i18n";

export const LanguageToggle = ({ lang, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref} data-testid="language-toggle">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="language-toggle-btn"
        className="flex items-center gap-1.5 px-3 py-2 rounded-full text-sm text-[#1A1A1A] hover:bg-[#FAFAFA] transition-colors"
      >
        <span aria-hidden="true">{current.flag}</span>
        <span className="hidden sm:inline">{current.name}</span>
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul
          className="absolute right-0 mt-2 w-44 rounded-xl bg-white shadow-lg border border-[#E5E5E5] py-1 z-50"
          data-testid="language-dropdown"
        >
          {LANGUAGES.map((l) => {
            const active = l.code === lang;
            return (
              <li key={l.code}>
                <button
                  type="button"
                  onClick={() => {
                    onChange(l.code);
                    setOpen(false);
                  }}
                  data-testid={`language-option-${l.code}`}
                  className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 transition-colors ${
                    active
                      ? "text-[#0AADA0] bg-[#0AADA0]/5"
                      : "text-[#1A1A1A] hover:bg-[#FAFAFA]"
                  }`}
                >
                  <span aria-hidden="true">{l.flag}</span>
                  <span>{l.name}</span>
                  {active && <span className="ml-auto text-[#0AADA0]">✓</span>}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
